import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = [
    'group',
    'percentageContainer',
    'fixedRateContainer',
    'percentage',
    'fixedRate',
    'result',
  ];

  initialize(){
    this.cPrice = parseFloat(this.data.get('price'));
    this.updatePath = this.data.get('updatePath');
  }

  connect(){
  }

  groupChanged(e){
    const val = this.groupTarget.value;
    if(val === "percentage"){
      this.fixedRateContainerTarget.classList.add('d-none');
      this.percentageContainerTarget.classList.remove('d-none');
      return;
    }

    if(val === "fixed_rate"){
      this.percentageContainerTarget.classList.add('d-none');
      this.fixedRateContainerTarget.classList.remove('d-none');
      return;
    }
  }

  percentageInput(e){
    const feeAffiliator = window.Util.addThousandSeparator(this.cPrice * (parseFloat(this.percentageTarget.value) / 100.0));
    const receivable = window.Util.addThousandSeparator(this.cPrice * (1.0 - (parseFloat(this.percentageTarget.value) / 100.0)));
    this.resultTarget.innerHTML = `
      <div class="">
        <b>Affiliator</b> :
        <span class="text-primary">Rp${feeAffiliator}</span>
      </div>
      <div class="">
        <b>Taxsam</b> :
        <span class="text-success">Rp${receivable}</span>
      </div>
    `;
  }

  fixedRateInput(e){
    const val = this.parseInputPriceToFloat(this.fixedRateTarget.value);
    const feeAffiliator = window.Util.addThousandSeparator(val);
    const receivable = window.Util.addThousandSeparator(this.cPrice - val);
    this.resultTarget.innerHTML = `
      <div class="">
        <b>Affiliator</b> :
        <span class="text-primary">Rp${feeAffiliator}</span>
      </div>
      <div class="">
        <b>Taxsam</b> :
        <span class="text-success">Rp${receivable}</span>
      </div>
    `;
  }

  parseInputPriceToFloat(value){
    let result = value.split(",")[0];
    value = value.replaceAll(".","");
    return parseFloat(value);
  }

  save(e){
    window.KTApp.blockPage();
    window.Ajax.put(this.updatePath, this.ajaxOptions);
  }

  retrievePayload(){
    return {
      affiliator_comission_setting: {
        group: this.groupTarget.value,
        percentage: this.percentageTarget.value,
        price: this.parseInputPriceToFloat(this.fixedRateTarget.value),
      }
    };
  }

  handleSuccess(responseText){
    window.location.reload();
  }

  handleFail(responseText){
    console.log('[ERROR]', responseText);
    try {
      const parsedResponse = JSON.parse(responseText);
      window.Flash.show("danger", parsedResponse.message);
      return;
    } catch (e){
      window.Flash.show("danger", responseText);
      return;
    }
  }

  handleDone(){
    window.KTApp.unblockPage();
  }

  get ajaxOptions(){
    return {
      data: JSON.stringify(this.retrievePayload()),
      onSuccess: this.handleSuccess.bind(this),
      onFail: this.handleFail.bind(this),
      onDone: this.handleDone.bind(this),
      headers: [
        {
          key: "Content-Type",
          value: "application/json",
        },
        {
          key: "X-CSRF-Token",
          value: window.Util.getCsrfToken(),
        },
      ]
    };
  }
}

